<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25.274" height="32.946" viewBox="0 0 25.274 32.946">
    <g id="Gruppe_1" data-name="Gruppe 1" transform="translate(-195.387 -368)">
      <g id="Gruppe_171" data-name="Gruppe 171" transform="translate(196.387 369)">
        <rect id="Rechteck_78" data-name="Rechteck 78" width="23.274" height="27.929" rx="2" transform="translate(0 3.016)" fill="none" stroke="#383737" stroke-linejoin="round" stroke-width="2"/>
        <path id="Pfad_122" data-name="Pfad 122" d="M387.439,351v1.957a1.957,1.957,0,0,1-1.957,1.957h-6.525A1.957,1.957,0,0,1,377,352.957V351" transform="translate(-370.926 -348.39)" fill="none" stroke="#383737" stroke-miterlimit="10" stroke-width="2"/>
        <path id="Pfad_123" data-name="Pfad 123" d="M381,349.61a2.61,2.61,0,0,1,5.22,0" transform="translate(-372.316 -347)" fill="none" stroke="#383737" stroke-miterlimit="10" stroke-width="2"/>
        <line id="Linie_17" data-name="Linie 17" x2="10.474" transform="translate(2.327 11.162)" fill="none" stroke="#383737" stroke-miterlimit="10" stroke-width="2"/>
        <path id="Pfad_124" data-name="Pfad 124" d="M391,364.3l1.3,1.3,2.61-2.61" transform="translate(-375.792 -352.561)" fill="none" stroke="#383737" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        <line id="Linie_18" data-name="Linie 18" x2="10.474" transform="translate(2.327 18.145)" fill="none" stroke="#383737" stroke-miterlimit="10" stroke-width="2"/>
        <path id="Pfad_125" data-name="Pfad 125" d="M391,374.3l1.3,1.3,2.61-2.61" transform="translate(-375.792 -356.036)" fill="none" stroke="#383737" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        <line id="Linie_19" data-name="Linie 19" x2="10.474" transform="translate(2.327 25.127)" fill="none" stroke="#383737" stroke-miterlimit="10" stroke-width="2"/>
        <path id="Pfad_126" data-name="Pfad 126" d="M391,384.3l1.3,1.3,2.61-2.61" transform="translate(-375.792 -359.512)" fill="none" stroke="#383737" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "inventoryIcon"
}
</script>

<style scoped>

</style>
